import React from 'react';
import './accountFinanceHero.scss';
// import {ReactComponent as ELEMENT_01} from "assets/business-education-assets/elements/be_element_01.svg";

const AccountFinanceHero = () => {
    return (
        <div className={'account-finance-hero'}>
            {/*<ELEMENT_01 className={'account-finance-hero_element_01'}/>*/}
            <div className="account-finance-hero_wrapper">
                <h1>Accounting & Financial Guidance </h1>
            </div>

        </div>
    );
};
export default AccountFinanceHero;
